<tc-setup-grid
        #setupGrid
        [readOnly]="false"
        [colDefConfig]="colDefConfig"
        [setupGridComp]="this"
        [dataSource]="this"
        [actionColumnWidth]="130">
</tc-setup-grid>

